import React from "react";

import { Grid } from "@mui/material";

import { AppSwitch } from "../../../../../../../components/Generic/AppSwitch";
import { AditionalInfo, Loading, MainGrid, SubTitle, Wrapper } from "./styles";

interface Props {
  title: string;
  aditionalInfo: string[];
  attribute: string;
  updateSecurity: (value: boolean) => void;
  selectedOption?: string[];
  value?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  children?: React.ReactNode;
}
const SecurityItem = ({
  title,
  aditionalInfo,
  value,
  updateSecurity,
  disabled,
  isLoading,
  attribute,
  selectedOption,
  children,
}: Props) => {
  const renderSwitch = () => {
    if (isLoading && selectedOption?.includes(attribute)) {
      return <Loading size={42} />;
    }

    return (
      <AppSwitch
        checked={value}
        onChange={(_: React.ChangeEvent<HTMLInputElement>, checked: boolean) => updateSecurity(checked)}
        disabled={disabled}
      />
    );
  };

  return (
    <MainGrid item container xs={12}>
      <Wrapper item container xs={12} justifyContent="space-between" alignItems="center">
        <Grid item>
          <SubTitle>{title}</SubTitle>
          {aditionalInfo?.map((info, index) => (
            <AditionalInfo key={index}>{info}</AditionalInfo>
          ))}
        </Grid>
        <Grid item>{renderSwitch()}</Grid>
      </Wrapper>
      <Grid item xs={12}>
        {children}
      </Grid>
    </MainGrid>
  );
};

export default SecurityItem;
